"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _ServerSideEncryptionRules_1 = require("./_ServerSideEncryptionRules");
exports._ServerSideEncryptionConfiguration = {
    type: "structure",
    required: ["Rules"],
    members: {
        Rules: {
            shape: _ServerSideEncryptionRules_1._ServerSideEncryptionRules,
            locationName: "Rule"
        }
    }
};
//# sourceMappingURL=_ServerSideEncryptionConfiguration.js.map